import React from "react";
import PropTypes from "prop-types";

import { add } from "domain/Game/api";
import Icon from "components/Icon";
import Button from "ui/Button";
import AddPlayerInterface from "components/AddPlayerInterface";
import { renderBlackListAlert } from "components/AddPlayerInterface/additional";
import AnimatedModal from "components/Modal/AnimatedModal";
import InvitationsModalGroupList from "components/GameInvitations/Modal/GroupList/Component";

class AddPlayer extends React.Component {
    state = {
        showModal: false,
        error: null,
    };

    toggleModal = () =>
        this.setState(({ showModal }) => ({ showModal: !showModal }));

    onSelect = async (player) => {
        const { isRegular } = this.props;
        try {
            this.setState({ error: null });
            const { gameId, updateGameData } = this.props;
            const response = await add(
                gameId,
                player.id,
                isRegular ? "regular_games" : "games"
            );

            updateGameData(
                gameId,
                isRegular ? response?.regular_game : response?.game
            );
        } catch (e) {
            this.setState({ error: e?.message });
        }
    };

    render() {
        const { players, gameId, isRegular, invitedGroups } = this.props;
        const { showModal, error } = this.state;

        return (
            <div className="flex jcc">
                {error && (
                    <AnimatedModal
                        visible={true}
                        title={`Внимание!`}
                        onClose={() => this.setState({ error: null })}
                        closeOnOverlay={true}
                        modificators={[`small-col`]}
                    >
                        {() => (
                            <>
                                <p className="text-center c-gs-medium-em mb-32">
                                    {error}
                                </p>
                                <div className="btn-group-row">
                                    <Button
                                        primary
                                        size="medium"
                                        mixes={[`m-x-auto`]}
                                        onClick={() =>
                                            this.setState({ error: null })
                                        }
                                    >
                                        <span className="btn__span">Ок</span>
                                    </Button>
                                </div>
                            </>
                        )}
                    </AnimatedModal>
                )}
                <Button
                    text
                    size="medium"
                    onClick={this.toggleModal}
                    mixes={[`w-100`, `bg-white`]}
                >
                    <span className="icon-container mr-15">
                        <Icon type="plus" inheritColor />
                    </span>
                    Добавить игроков / список
                </Button>

                {showModal && (
                    <AddPlayerInterface
                        onSelect={this.onSelect}
                        onClose={this.toggleModal}
                        multiple
                        selectedUsers={players}
                        renderAdditionalInItem={renderBlackListAlert}
                    >
                        <InvitationsModalGroupList
                            gameId={gameId}
                            invitedGroups={isRegular ? invitedGroups : []}
                            toggleModal={this.toggleModal}
                            isInvate={false}
                            isRegular={isRegular}
                        />
                    </AddPlayerInterface>
                )}
            </div>
        );
    }
}

AddPlayer.defaultProps = {
    isRegular: false,
};

AddPlayer.propTypes = {
    updateGameData: PropTypes.func.isRequired,
    gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    players: PropTypes.arrayOf(PropTypes.object),
    isRegular: PropTypes.bool,
    invitedGroups: PropTypes.array,
};

export default AddPlayer;
